import Grid from "@mui/material/Grid";
import TransportProviderDescription from "../TransportProviderDescription";
import TransportProviderLogo from "../TransportProviderLogo";
import { type TransportProviderLogoType } from "../types";

interface TransportProviderHeaderProps {
  title?: string | null;
  titleClassName?: string;
  fallbackTitle?: string;
  shortDescription?: string | null;
  providerLogo?: TransportProviderLogoType | null;
}

export default function TransportProviderHeader({
  title,
  titleClassName = "sbb__title",
  fallbackTitle,
  shortDescription,
  providerLogo
}: TransportProviderHeaderProps) {
  const displayTitle = title?.trim() || fallbackTitle?.trim();
  const hasLogo = Boolean(providerLogo?.url);
  const showBody = Boolean(shortDescription?.trim() || hasLogo);

  if (!displayTitle && !showBody) {
    return null;
  }

  return (
    <Grid container item xs={12} className="transport-provider-header" pb={4} pl={4.5} pr={{ xs: 2, sm: 4.5 }}>
      {displayTitle && (
        <Grid item xs={12} className="transport-provider-header__title">
          <div className={titleClassName}>{displayTitle}</div>
        </Grid>
      )}
      {showBody && (
        <Grid container item xs={12} className="transport-provider-header__body">
          <Grid item xs={12} md={hasLogo ? 6 : 12} className="transport-provider-header__content">
            <TransportProviderDescription description={shortDescription} />
          </Grid>
          {hasLogo && (
            <Grid item xs={12} md={6} className="transport-provider-header__logo">
              <TransportProviderLogo logo={providerLogo} />
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
}
